import Modal from "react-modal";
import DragNdrop from "./DragNDrop";
import { AppBar, IconButton, Toolbar, Typography, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import React from "react";
import ItemCodesSearchNSelect from "../PreAuth/components/request/ItemCodesSearchNSelect";
import priceList from "../../gql/priceList";
import { useMutation } from "@apollo/client";
import toast from "react-hot-toast";
import { useParams } from "react-router";
import { useEffect } from "react";
import AppModal from "../../components/AppModal";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { set } from "immutable";
import CustomFilterInput from "../../shared/CustomFilterInput";
import AppButton from "../../shared/AppButton";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function OuterPriceListServiceModal({
  showPriceListServiceModal,
  setShowPriceListServiceModal,
  payersData,
  item,
  refetchSpecificPriceList,
  pageNo,
  limit,
}) {
  const effectiveDate = new Date().toISOString();
  const { payerId } = useParams();
  const { t, i18n } = useTranslation();

  const types = [
    { id: "medical-devices", name: "Medical Devices" },
    { id: "medication-codes", name: "Medication Codes" },
    { id: "transportation-srca", name: "Transportation SRCA" },
    { id: "imaging", name: "Imaging" },
    { id: "services", name: "Services" },
    { id: "laboratory", name: "Laboratory" },
    { id: "oral-health-op", name: "Oral Health OP" },
    { id: "procedures", name: "Procedures" },
  ];

  const onSuccessfulCreateRequestResponse = (data) => {
    if (data?.createPriceList) {
      toast.success(data?.createPriceList?.message);
      setShowPriceListServiceModal(false);
    }
  };

  const onSuccessfulUpdateRequestResponse = (data) => {
    if (data?.updatePriceList) {
      toast.success(data?.updatePriceList?.message);
      setShowPriceListServiceModal(false);
    }
  };

  const onResponseError = (error) => {
    toast.error(`${error?.message}`);
  };

  const [specificPriceList, { data, loading, error }] = useMutation(
    priceList.CREATE_SPECIFIC_PRICE_LIST,
    {
      update(proxy, result) {
        onSuccessfulCreateRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  const [updatePriceList, {}] = useMutation(priceList.UPDATE_PRICE_LIST, {
    update(proxy, result) {
      onSuccessfulUpdateRequestResponse(result.data);
    },
    onError(error) {
      onResponseError(error.graphQLErrors[0]);
    },
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    resetForm,
    setFieldValue,
    isValid,
    setValues,
  } = useFormik({
    initialValues: {
      service_type: "",
      unit_price: "",
      factor: "",
      non_standard_code: "",
      non_standard_desc: "",
      service_code: "",
      service_desc: "",
      payer_id: payerId,
      effective_date: effectiveDate,
      id: 0,
    },

    validationSchema: () => {
      return Yup.object().shape({
        service_type: Yup.string().required(t("Type required")),
        payer_id: Yup.string().required("payer is required"),
        unit_price: Yup.number().required(t("Unit Price required")),
        factor: Yup.number().required(t("Factor required")),
        non_standard_code: Yup.string().required(
          t("Non Standard Code required"),
        ),
        non_standard_desc: Yup.string().required(
          t("Non Standard Description required"),
        ),
        service_code: Yup.string().required(t("Standard code is required")),
        service_desc: Yup.string().required(
          t("Standard code description is required"),
        ),
      });
    },

    onSubmit: (values) => {
      if (item) {
        delete values?.payer_id;
        delete values?.effective_date;
        updatePriceList({ variables: { input: values } }).then(() => {
          setShowPriceListServiceModal(false);
        });
      } else {
        delete values?.id;
        specificPriceList({ variables: { input: values } }).then(() => {
          setShowPriceListServiceModal(false);
        });
      }
    },
  });

  useEffect(() => {
    if (item) {
      setValues({
        service_type: item.service_type || "",
        unit_price: item.unit_price || "",
        factor: item.factor || "",
        non_standard_code: item.non_standard_code || "",
        non_standard_desc: item.non_standard_desc || "",
        service_code: item.service_code || "",
        service_desc: item.service_desc || "",
        payer_id: item.payer_id || payerId,
        effective_date: item.effective_date || effectiveDate,
        id: item?.id || 0,
      });
    }
  }, [item]);

  return (
    <div>
      <BootstrapDialog
        onClose={() => setShowPriceListServiceModal(false)}
        aria-labelledby="customized-dialog-title"
        open={showPriceListServiceModal}
        PaperProps={{
          className:
            "w-full !max-w-[750px] sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-[750px] !z-40",
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t("Upload Price List Services")}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setShowPriceListServiceModal(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <div className="benefeciary-create !m-0 !p-0">
            <div className="personal-data flex flex-col gap-4 !shadow-none !border-none">
              <div className="personal-fields grid grid-cols-1 md:grid-cols-2 gap-2">
                <CustomFilterInput
                  label={t("Select Payer*")}
                  name="payer_id"
                  value={values.payer_id}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Select Payer")}
                  isSelect
                  error={errors.payer_id}
                  touched={touched.payer_id}
                  renderOptions={() =>
                    payersData?.map((category) => (
                      <optgroup
                        label={
                          category?.name_en
                            ? category?.name_en + ` (${category?.license_id})`
                            : ""
                        }
                        key={category.id}
                      >
                        {category.payers.map((insurance, index) => (
                          <option key={index} value={insurance.id}>
                            {insurance.name_en} ({insurance?.license_id})
                          </option>
                        ))}
                      </optgroup>
                    ))
                  }
                />

                <CustomFilterInput
                  label={t("Select Type*")}
                  name="service_type"
                  value={values.service_type}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Select Type")}
                  isSelect
                  options={types}
                  error={errors.service_type}
                  touched={touched.service_type}
                />

                <div className="field flex flex-col gap-1">
                  <label className="block font-semibold text-[12px] text-gray-700 capitalize">
                    {t("Search for Code*")} ({values?.service_code})
                  </label>
                  <ItemCodesSearchNSelect
                    typeName={values.service_type}
                    setFieldValue={(val) => {
                      setFieldValue(`service_code`, val.code);
                      setFieldValue(`service_desc`, val.description);
                    }}
                  />
                  {errors.service_code && touched.service_code ? (
                    <p className="text-[10px] text-red-500 mt-1 font-medium">
                      {errors.service_code}
                    </p>
                  ) : null}
                </div>

                <CustomFilterInput
                  label={t("Non Standard Code*")}
                  name="non_standard_code"
                  value={values.non_standard_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Non Standard Code")}
                  error={errors.non_standard_code}
                  touched={touched.non_standard_code}
                />

                <CustomFilterInput
                  label={t("Non Standard Description*")}
                  name="non_standard_desc"
                  value={values.non_standard_desc}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Non Standard Description")}
                  error={errors.non_standard_desc}
                  touched={touched.non_standard_desc}
                />

                <CustomFilterInput
                  label={t("Unit Price (SAR)*")}
                  name="unit_price"
                  value={values.unit_price}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Enter Unit Price")}
                  type="number"
                  error={errors.unit_price}
                  touched={touched.unit_price}
                />

                <CustomFilterInput
                  label={t("Factor*")}
                  name="factor"
                  value={values.factor}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Factor")}
                  type="number"
                  error={errors.factor}
                  touched={touched.factor}
                />
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <AppButton
            label={loading ? "..." : t("Submit")}
            onClick={handleSubmit}
            className="w-full md:w-auto"
          />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
